interface DonutSlice {
  label: string;
  value: number;
  color: string;
}

interface DonutChartProps {
  data: DonutSlice[];
  size?: number;
  centerLabel?: string;
  centerValue?: string;
}

export default function DonutChart({ data, size = 140, centerLabel, centerValue }: DonutChartProps) {
  const total = data.reduce((a, b) => a + b.value, 0);
  const r = 50;
  const cx = size / 2;
  const cy = size / 2;
  const strokeW = 18;
  const circumference = 2 * Math.PI * r;

  let cumulative = 0;
  const slices = data.map((d) => {
    const pct = d.value / total;
    const offset = circumference * (1 - cumulative);
    const dash = circumference * pct;
    cumulative += pct;
    return { ...d, pct, offset, dash };
  });

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      {/* Background circle */}
      <circle cx={cx} cy={cy} r={r} fill="none" stroke="#f1f5f9" strokeWidth={strokeW} />
      {slices.map((s, i) => (
        <circle
          key={i}
          cx={cx}
          cy={cy}
          r={r}
          fill="none"
          stroke={s.color}
          strokeWidth={strokeW}
          strokeDasharray={`${s.dash - 1.5} ${circumference - s.dash + 1.5}`}
          strokeDashoffset={s.offset}
          strokeLinecap="round"
          transform={`rotate(-90 ${cx} ${cy})`}
          style={{ transition: "stroke-dasharray 0.5s ease" }}
        />
      ))}
      {centerValue && (
        <text x={cx} y={cy - 4} textAnchor="middle" fontSize="16" fontWeight="700" fill="#1e293b">
          {centerValue}
        </text>
      )}
      {centerLabel && (
        <text x={cx} y={cy + 12} textAnchor="middle" fontSize="9" fill="#94a3b8">
          {centerLabel}
        </text>
      )}
    </svg>
  );
}
